// @flow
import styled from "styled-components";
import { connect } from "react-redux";
import { type ContextRouter } from "react-router";
import { NotFound } from "@nested/brand/src/pages/NotFound";
import {
  Breadcrumbs,
  blogWrapperStyles,
} from "../../components/Blog/Breadcrumbs";
import { Loader } from "../../components/Loader/Loader";
import { HR } from "../../components/Blog/HR";
import { RelatedPosts } from "../../components/Blog/RelatedPosts";
import { MetaTags } from "./MetaTags";
import { Author } from "./Author";
import { Slice } from "./Slice";
import { getBlogPostSaga } from "./ducks";
import { RichText } from "../../components/Blog/RichText";
import { BlogWrapper } from "../BlogLayout";

const Content = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

const Heading = styled.div`
  margin: auto;
  width: 100%;
`;

const ContentWrapper = styled.div`
  ${blogWrapperStyles}
`;

const Body = styled.div`
  margin-top: 10px;
`;

const Hero = styled.div`
  position: relative;
  height: 0px;
  padding-bottom: 50%;
`;

const HeroImage = styled.img`
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

type OuterProps = ContextRouter<{ id: string }>;

type Props = {
  ...OuterProps,
  content: RemoteContent<PrismicPost>,
};

export const PostComponent = ({ content }: Props) => {
  if (content?.fetched && content?.notFound) {
    return <NotFound />;
  }
  return (
    <BlogWrapper>
      <Loader content={content}>
        {(post) => (
          <div>
            <MetaTags post={post} />
            <Breadcrumbs category={post.data.category} />
            <ContentWrapper>
              <Content>
                <Heading>
                  {post.data.hero_image?.url && (
                    <Hero>
                      <HeroImage src={post.data.hero_image.url} />
                    </Hero>
                  )}
                  <RichText data-test="blog-post-title">
                    {post.data.title}
                  </RichText>
                  <RichText data-test="blog-post-description">
                    {post.data.description}
                  </RichText>
                </Heading>
                <Author author={post.data.author} />
              </Content>
            </ContentWrapper>
            <Body data-test="blog-post-body">
              {post.data.body.map((slice, index) => (
                <Slice key={index}>{slice}</Slice>
              ))}
            </Body>
            <ContentWrapper>
              <Content>
                <HR />
                <RelatedPosts
                  category={post.data.category}
                  posts={post.data.related_posts}
                />
              </Content>
            </ContentWrapper>
          </div>
        )}
      </Loader>
    </BlogWrapper>
  );
};

PostComponent.fetchData = getBlogPostSaga;

const mapStateToProps = (state, ownProps) => ({
  content: state.blog.post[ownProps.match.params.id],
});

export const Post = connect<Props, OuterProps, _, _, _, _>(mapStateToProps)(
  PostComponent,
);

export const UniversalRender = Post;
